import { AttachmentData, AttachmentStatus } from '../../../../../@types/types'

export const attachmentsToApi = (attachments: AttachmentData[]) =>
  attachments.filter((it) => it.state === AttachmentStatus.PERSISTED).map((it) => it.attachment!)
